(function (){
    'use strict';

    angular
        .module('services')
        .service('EventsService', EventsService);

    EventsService.$inject = ['$http', 'API_BASE'];

    function EventsService ($http, API_BASE) {
        var service = this;

        service.getOthersEvents  = getOthersEvents;

        function getOthersEvents() {
            return $http.get(API_BASE + '/travel-expenses/others-events');
        }
    }
})();